const fmvrHost = () => {
  switch (process.env.RAILS_ENV) {
    case "production":
      return "https://fmvr-prod.serverless.jibjab.com";

    case "staging":
      return "https://fmvr-stg.serverless.jibjab.com";

    case "qa":
      return "https://fmvr-qa.serverless.jibjab.com";

    case "integration2":
    case "integration":
    case "development":
      return "https://fmvr-int.serverless.jibjab.com";

    default:
      return "https://fmvr-prod.serverless.jibjab.com";
  }
};

export default {
  aboutPath: () => "https://www.glassdoor.com/Overview/Working-at-JibJab-Bros-Studios-EI_IE37910.11,30.htm",
  helpPath: () => "https://jibjab.zendesk.com/hc/en-us",
  requestHelpPath: () => "https://help.jibjab.com/hc/en-us/requests/new",
  twitterPath: () => "https://twitter.com/jibjab",
  facebookPath: () => "https://www.facebook.com/jibjab",
  instagramPath: () => "https://www.instagram.com/jibjab",
  pinterestPath: () => "https://www.pinterest.com/jibjabmediainc/",
  youtubePath: () => "https://www.youtube.com/user/JibJab",
  recaptchaPrivacy: () => "https://policies.google.com/privacy",
  recaptchaTerms: () => "https://policies.google.com/terms",
  googleVisionPath: (key) => `https://vision.googleapis.com/v1/images:annotate?key=${key}`,
  fmvrPath: (makeId) => `${fmvrHost()}/${makeId}`,
  californiaDataLinkPath: (email = null) =>
    email
      ? `https://docs.google.com/forms/d/e/1FAIpQLScyn6JigE1kbAd6BoULVE4qsXoR5R5kEtuFHXR1fZiELWJVoA/viewform?usp=pp_url&entry.414375083=${email}`
      : "https://docs.google.com/forms/d/e/1FAIpQLScyn6JigE1kbAd6BoULVE4qsXoR5R5kEtuFHXR1fZiELWJVoA/viewform?usp=sf_link",
};
